function create(opts) {
    var state = 'idle'; // idle | active | stopping | stopped
    var startTime = null;
    var maxDurationTimer = null;
    var minStopTimer = null;
    var container = null;
    var options = {
        initialMessage: (opts && opts.initialMessage) || 'Understanding the query',
        maxDuration: (opts && opts.maxDuration) || 15000,
        minDisplayTime: (opts && opts.minDisplayTime) || 300
    };

    function _getTextEl() {
        return container;
    }

    function _clearTimers() {
        if (maxDurationTimer) { clearTimeout(maxDurationTimer); maxDurationTimer = null; }
        if (minStopTimer) { clearTimeout(minStopTimer); minStopTimer = null; }
    }

    function _teardown() {
        if (state === 'stopped') return;
        _clearTimers();
        state = 'stopped';
    }

    function start(containerEl) {
        if (state !== 'idle') return;
        container = containerEl;
        state = 'active';
        startTime = Date.now();

        var txtEl = _getTextEl();
        if (txtEl) { txtEl.innerText = options.initialMessage; }

        maxDurationTimer = setTimeout(function() {
            forceStop();
        }, options.maxDuration);
    }

    function updateMessage(text) {
        if (state !== 'active') return;
        var txtEl = _getTextEl();
        if (txtEl && text) { txtEl.innerText = text; }
    }

    function stop() {
        if (state !== 'active') { _teardown(); return; }
        state = 'stopping';
        var elapsed = Date.now() - startTime;
        var remaining = options.minDisplayTime - elapsed;
        if (remaining > 0) {
            minStopTimer = setTimeout(_teardown, remaining);
        } else {
            _teardown();
        }
    }

    function forceStop() {
        _teardown();
    }

    return {
        start: start,
        updateMessage: updateMessage,
        stop: stop,
        forceStop: forceStop
    };
}

module.exports = { create: create };
